import Icon from '@mdi/react'
import styled from 'styled-components'

import theme from 'theme_'
import { H4 } from 'components/Typography'
import CommonLinkButton from 'components/Button/CommonLinkButton'
import CommonButton from 'components/Button/CommonButton'

export const SortPopupContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  /* mobile viewport bug fix */
  height: calc(100vh - calc(100vh - 100%));
  min-height: 100vh;
  min-height: -webkit-fill-available;
  background: ${theme.colors.grey};
  overflow: auto;
  z-index: ${theme.zIndex.loaderOverlay};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  animation: ${theme.animations.fadeIn} 0.2s ease;
  transition: all 0.2s ease;
`

export const SortPopupWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const SortPopupTitle = styled(H4)`
  display: flex;
  align-items: center;
  background: ${theme.colors.white};
  padding: 16px 12px;
  width: 100%;
  height: 56px;
`

export const SortPopupUl = styled.ul`
  padding: 0;
  margin: 0;
`

export const SortPopupLi = styled.li<{ selected: boolean }>`
  height: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
  background: ${(p) => p.selected && theme.colors.hover10};
  box-shadow: ${(p) =>
    p.selected &&
    `inset 0 1px 0 0 ${theme.colors.horizonOrange}, inset 0 -1px 0 0 ${theme.colors.horizonOrange}`};
`

export const SortPopupIcons = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 64px;
`

export const SortPopupIcon = styled(Icon)<{ selected: boolean }>`
  height: 22px;
  width: 22px;
  transition: all 0.2s ease;
  color: ${(p) =>
    p.selected ? theme.colors.horizonOrange : theme.colors.duneWarmGrey};
`

export const SortPopupIconButton = styled(CommonLinkButton)`
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  :last-child {
    margin-left: 16px;
  }
`

export const SortPopupButtons = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 24px;
  background: ${theme.colors.white};
`

export const SortPopupCancelButton = styled(CommonButton)`
  background: transparent;
  width: 100%;
`

export const SortPopupApplyButton = styled(CommonButton)`
  width: 100%;
`
